import { render, staticRenderFns } from "./additional-supervisor-form.component.vue?vue&type=template&id=21afee4d&"
import script from "./additional-supervisor-form.component.ts?vue&type=script&lang=ts&"
export * from "./additional-supervisor-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./additional-supervisor-form.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports